export enum CountersignRole {
  FireSafetyManager = 0,
  FireSafetyCoordinator = 1,
  WorkEnvironmentManager = 2,
  BAS_U = 3,
  Client = 4,
  PropertyOwner = 5,
  OperationsManager = 6,
  FacilityManager = 7,
  SecurityManager = 8,
  OtherRole = 9
}